import { IItem } from '../../timeline/store/timeline.types'
import { ILabsState } from '../../procedures/labs/store/labs.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { IEKGEvent } from '../store/ekgImport.types'
import { LabsConstants } from '../../procedures/labs/store/labs.constants'

interface CreateLabsProcedureProps {
  procedureEvent: IEKGEvent
  ptaCutoff: Date | null
}

export interface LabsProcedureObject {
  labsState: ILabsState
  timelineItem: IItem
}

const createLabsProcedure = (props: CreateLabsProcedureProps): LabsProcedureObject => {
  const { procedureEvent, ptaCutoff } = props

  const clientEventId = (procedureEvent.eventVitals.clientEventId as number).toString()
  const vsAction = procedureEvent.eventVitals.vsAction
  const isEkgImport = procedureEvent.eventVitals.isEkgImport
  const itemComments = procedureEvent.procedureComments || ''
  const itemSubHeader = `By , Lab values: attempts:1, Comments: ${itemComments}.`
  const clientCorrelationId = `patient.labsStateList${clientEventId}`
  const eventDate = new Date(procedureEvent.dtDevice)
  const isPTA = !!ptaCutoff && eventDate < ptaCutoff

  const timelineItem: IItem = {
    key: clientEventId,
    clientCorrelationId,
    itemType: 'Procedures',
    event: 'Labs',
    grid: true,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    labelHeader: procedureEvent.eventVitals.time,
    subHeader: procedureEvent.eventVitals.date,
    eventSubHeader: itemSubHeader,
    rowActionType: TimelineConstants.SET_LABS_PROCEDURE_ITEM,
    defaultHref: TabConstants.LABS_PROCEDURE,
    date: new Date(procedureEvent.dtDevice),
    clientEventId: clientEventId,
    ...(vsAction && { vsAction: vsAction }),
    ...(isEkgImport && { isEkgImport: isEkgImport }),
  }

  const labsState: ILabsState = {
    key: clientEventId,
    date: procedureEvent.eventVitals.date,
    time: procedureEvent.eventVitals.time,
    assessedBy: null,
    rolePerforming: null,
    rolePerformingPNNV: null,
    attempts: '1',
    successfulAttempt: true,
    ABG_ACCESS: null,
    ACTC: '',
    ACTK: '',
    ALB: '',
    ALCOHOL_BLOOD: '',
    ALCOHOL_BREATH: '',
    ALP: '',
    ALT: '',
    AMYLASE: '',
    ANION_GAP: '',
    APAP: '',
    APHI: '',
    AST: '',
    BANDS: '',
    BASOPHILS: '',
    BE: '',
    BILI: '',
    BNP: '',
    BUN: '',
    CA: '',
    CL: '',
    COHB: '',
    CO2: '',
    CPK: '',
    CPK_MB: '',
    CR: '',
    CRP: '',
    CTNT: '',
    DDIMER: '',
    EGFR: '',
    EOSINOPHILS: '',
    ERYTHROCYTE_MORPHOLOGY: '',
    ERYTHROCYTE_SEDIMENT_RATE: '',
    GGT: '',
    GLU: '',
    HCG_SERUM: '',
    HCG_URINE: '',
    HCO3: '',
    HCT: '',
    HGB: '',
    HS_CRP: '',
    HS_CTNT: '',
    HSTROPONIN: '',
    HS_TROPONIN_UNIT: '',
    ICA: '',
    INR: '',
    K: '',
    LACTATE_ARTERIAL: '',
    LACTATE_VENOUS: '',
    LDH: '',
    LEU: '',
    LIPASE: '',
    LYMPHOCYTES: '',
    MCH: '',
    MCHC: '',
    MCV: '',
    MESA: '',
    MG: '',
    MONOCYTES: '',
    MYOGLOBIN: '',
    NA: '',
    NEUTROPHILS: '',
    NH3: '',
    NH4: '',
    NO3: '',
    OTHER: '',
    OSMOLALITY: '',
    PCO2: '',
    PHB: '',
    PHT: '',
    PH_ABG: '',
    PH_VENOUS: '',
    PLTS: '',
    PO2: '',
    PO4: '',
    PRO: '',
    PT: '',
    pta: isPTA,
    PTH: '',
    PH: '',
    PTT: '',
    RBC: '',
    RDW: '',
    RETICULOCYTE_COUNT: '',
    SAT: '',
    SG: '',
    SVO2: '',
    TBILI: '',
    TCO2: '',
    TROPONIN: '',
    WBC_DIFF: '',
    WBC: '',
    procedureComplications: [],
    authorization: null,
    comments: itemComments,
    type: 'Labs',
    isEkgImport: 1,
    nemsisCode: LabsConstants.LABS_NEMSIS_CODE,
    procedurePerformedByAnotherUnit: null,
    procedurePerformedByAnotherUnitPNNV: null,
  }

  const newLabsProcedureObject: LabsProcedureObject = {
    labsState,
    timelineItem,
  }

  return newLabsProcedureObject
}

export default createLabsProcedure
